export default class Mutex {
	private mutex = Promise.resolve();

	lock(): PromiseLike<() => void> {
		// Lets just let this thing do its thing as it works.
		// oxlint-disable-next-line no-empty-function
		let begin: (unlock: () => void) => void = () => {};

		this.mutex = this.mutex.then(() => new Promise(begin));

		return new Promise((resolve) => {
			begin = resolve;
		});
	}

	async dispatch<T>(fn: (() => T) | (() => PromiseLike<T>)): Promise<T> {
		const unlock = await this.lock();
		try {
			return await Promise.resolve(fn());
		} finally {
			unlock();
		}
	}
}
